import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Star = ({
  size,
  type,
  theme,
  className,
  dataTestId = "star-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      d="M14.885 6.797a.386.386 0 0 0 .094-.402.388.388 0 0 0-.314-.263l-4.356-.634-1.943-3.882a.405.405 0 0 0-.533-.17.308.308 0 0 0-.172.17L5.702 5.513l-4.356.619c-.22.015-.36.217-.345.433.016.093.063.17.126.232l3.165 3.047-.752 4.284c-.032.217.11.418.313.449.078.015.172 0 .25-.046l3.903-2.027 3.902 2.027a.409.409 0 0 0 .532-.155c.047-.077.047-.17.047-.248l-.752-4.284 3.15-3.047Zm-4.18 5.49-.517-2.945 2.165-2.095-2.993-.435-1.348-2.694L6.648 6.83l-2.976.423 2.167 2.086-.516 2.94 2.683-1.393 2.7 1.401Z"
      clipRule="evenodd"
    />
  </SVGIcon>
);
